var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'home-page': _vm.classPage, mobile__active: _vm.mobileStatus },attrs:{"id":"app"}},[_c('router-view'),_c('AppDialog'),_c('AppToast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }